{
  "version": 1,
  "asset_id": "9c340b3c-82dc-4777-adb5-7f902be0f232",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/9c340b3c-82dc-4777-adb5-7f902be0f232/fun-in-sun.jpg",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/9c340b3c-82dc-4777-adb5-7f902be0f232/fun-in-sun.jpg",
  "original_filename": "fun-in-sun.jpg",
  "size": 227946,
  "content_type": "image/jpeg",
  "created_at": "2026-07-14T02:53:52Z"
}
